// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CashflowFromJSON, CashflowToJSON, TaParametersFromJSON, TaParametersToJSON, } from './';
export function CashflowCustomModelFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'revisions': !exists(json, 'revisions') ? undefined : json['revisions'],
        'lastUpdated': !exists(json, 'lastUpdated') ? undefined : new Date(json['lastUpdated']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'asOfDate': new Date(json['asOfDate']),
        'commitment': !exists(json, 'commitment') ? undefined : json['commitment'],
        'modelVersion': !exists(json, 'modelVersion') ? undefined : json['modelVersion'],
        'type': json['type'],
        'cashflows': !exists(json, 'cashflows') ? undefined : json['cashflows'].map(CashflowFromJSON),
        'taParameters': !exists(json, 'taParameters') ? undefined : TaParametersFromJSON(json['taParameters']),
    };
}
export function CashflowCustomModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'createdBy': value.createdBy,
        'revisions': value.revisions,
        'lastUpdated': value.lastUpdated === undefined ? undefined : value.lastUpdated.toISOString().substr(0, 10),
        'description': value.description,
        'asOfDate': value.asOfDate.toISOString().substr(0, 10),
        'commitment': value.commitment,
        'modelVersion': value.modelVersion,
        'type': value.type,
        'cashflows': value.cashflows === undefined ? undefined : value.cashflows.map(CashflowToJSON),
        'taParameters': TaParametersToJSON(value.taParameters),
    };
}
/**
* @export
* @enum {string}
*/
export var CashflowCustomModelTypeEnum;
(function (CashflowCustomModelTypeEnum) {
    CashflowCustomModelTypeEnum["TaParameters"] = "taParameters";
    CashflowCustomModelTypeEnum["Cashflows"] = "cashflows";
})(CashflowCustomModelTypeEnum || (CashflowCustomModelTypeEnum = {}));
